﻿import React from 'react';

import moment from 'moment';
import isISO8601 from 'validator/lib/isISO8601';
import Personnummer from 'personnummer';
import isValidEmail from 'is-valid-email';

import ErrorMessage from '../Components/ErrorMessage';

import { replaceSwedishCountryCodeWithZero, sanitizeNumber, startsWithZero, isNumber } from './helpers';

export function required(value, props, components) {
    let valid = false;
    // series of checkboxes/radios where at least one has to be checked
    if (typeof components !== 'undefined' && components[props.name].length > 1) {
        valid = components[props.name].reduce((oneValid, radio) => {
            let radioEl = document.getElementById(radio.id);
            return oneValid || radioEl.checked;
        }, false);
    } else {
        valid = props.isCheckable ? props.checked : (value || value != 0);
    }

    if (!valid) {
        return <ErrorMessage forId={props.id}/>;
    }
}

export function minLength(minLen) {
    return (value, props, components) => {
        if ((value + '').length < minLen && value != null && value != '') {
            return typeof props !== 'undefined' && props
                ? <ErrorMessage forId={props.id}/>
                : false;
        }
    };
}

export function isEligble(value, props, components) {
    const birthdate = moment(value);
    let today = moment();
    const age = moment(today, 'YYYY-MM-DD').diff(moment(birthdate), 'years');

    if (age >= 7) {
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function isAdult(value, props) { 
    let date = value.substring(0, 8);
    const birthdate = moment(date);
    let today = moment();
    const age = moment(today, 'YYYY-MM-DD').diff(moment(birthdate), 'years');

    if (age < 18) {       
        return typeof props !== 'undefined' ? <ErrorMessage message={"Medförsäkrad måste vara över 18 år"}/> : false;
    }
}

export function exactLength(len) {
    return (value, props, components) => {
        if ((value + '').length != len && value != null && value != '') {
            return typeof props !== 'undefined' && props
                ? <ErrorMessage forId={props.id} />
                : false;
        }
    };
}

export function requiredIfOtherChecked(validatorFunc = null) {
    const valid = validatorFunc ? validatorFunc : required;

    return (value, props, components) => {
        let validatedEl = document.getElementById(props.id);
        const otherCheckedId = validatedEl.dataset.validationOtherCheckedId;
        let otherCheckedEl = document.getElementById(otherCheckedId);

        if (otherCheckedEl.checked) {
            return valid(value, props);
        }
    };
}

export function requiredIfOtherEmpty(validationFunc) {
    return (value, props, components) => {
        let validatedEl = document.getElementById(props.id);
        const otherInputId = validatedEl.dataset.validationOtherRequiredId;
        let otherInputEl = document.getElementById(otherInputId);

        if (otherInputEl.classList.contains('is-invalid-input') || !otherInputEl.value) {
            return validationFunc(value, props);
        }
    };
}

export function requiredIfOtherNotChecked(validatorFunc = null) {
    const valid = validatorFunc ? validatorFunc : required;

    return (value, props, components) => {
        let validatedEl = document.getElementById(props.id);
        const otherCheckedId = validatedEl.dataset.validationOtherCheckedId;
        let otherCheckedEl = document.getElementById(otherCheckedId);

        if (!otherCheckedEl.checked) {
            return valid(value, props);
        }
    };
}

export function ifNotEmpty(validationFunc) {
    return (value, props) => {
        if (typeof value !== 'undefined' && value.length > 0) {
            return validationFunc(value, props);
        }
    };
}

export function mustBeEqual(input0, input1, errorMessage) {
    errorMessage = typeof errorMessage != 'undefined' ? errorMessage : ' ';

    return (value, props, components) => {
        const bothUsed = components[input0][0].isUsed && components[input1][0].isUsed;
        const bothChanged = components[input0][0].isChanged && components[input1][0].isChanged;

        if (bothChanged && bothUsed && components[input0][0].value !== components[input1][0].value) {
            return <ErrorMessage message={errorMessage} />;
        }
    };
}

export function validateEmailAndMatch(input1, input2, errorMessageEmail, errorMessageMatch) {

    return (value, props, components) => {
        const emailValue = components[input1][0].value;
        const confirmEmailValue = components[input2][0].value;

        // Check if correct email format
        if (!isValidEmail(value)) {
            return <ErrorMessage message={errorMessageEmail} />;
        }

        // Check if the two email addresses match
        if (emailValue !== confirmEmailValue) {
            return <ErrorMessage message={errorMessageMatch} />;
        }
    };
}

export function isPositiveInteger(value, props, components) {
    if(!/^\+?[1-9]\d*$/.test(value)) {
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function isPositiveIntegerRange(min, max) {
    return (value, props, components) => {
        if(!/^\+?[1-9]\d*$/.test(value)
            || parseInt(value) > max
            || parseInt(value) < min)
        {
            return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
        }
    }
}
export function isIntegerBetweenLengthRange(min, max) {
    return (value, props, components) => {
        if(parseInt(value) != value) {
            return <ErrorMessage forId={props.id} />;
        }

        if ((value + '').length > max || (value + '').length < min) {
            return <ErrorMessage forId={props.id} />;
        }

        return false;
    }
}

// export isPositiveIntegerRange;

export function numericalString(value, props, components) {
    if (!(/^[0-9]+$/.test(value)) && value != null && value != '') {
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function validEmail(value, props, components) {
    if (!isValidEmail(value)) {
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function validPersonalIdentityNo(value, props, components) {
    const val = value.replace(/-/g, '');
    try {
        const number = Personnummer.parse(val);
        if (val.length !== 12 || number.isCoordinationNumber()) {
            return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
        }
    } catch (e) { // Personnummer.parse throws an error which shouldn't be a problem, but just in case, catch it here
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function validPersonalIdentityOrCoordinationNo(value, props, components) {
    // Coordination Number = Samordningsnummer
    const val = value.replace(/-/g, '');
    if (val.length !== 12 || !Personnummer.valid(val)) {
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function ownPersonalIdNumberNotSuppliedForCoinsuree(insureePersonalId) {
    return (value, props, components) => {
        const val = value.replace(/-/g, '');

        try {
            const numbersMatch = Personnummer.parse(insureePersonalId).format() == Personnummer.parse(val).format();
            if (val.length !== 12 || numbersMatch) {
                const message = 'Du verkar ha fyllt i ditt eget personnummer på en försäkring för medförsäkrad. Ange istället medförsäkrads personnummer för att gå vidare.';
                return <ErrorMessage message={message} />;
            }
        } catch (e) { // Personnummer.parse throws an error which shouldn't be a problem, but just in case, catch it here
            return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
        }
    }
}

function validAbstractPhoneNumber(value, props, numberFunction) {
    const number = sanitizeNumber(
        replaceSwedishCountryCodeWithZero(value)
    );

    // Allow for blank values = clear value in database
    if (value.length == 0) {
        return;
    }

    if (!startsWithZero(number) || !isNumber(number) || !numberFunction(number)) {
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function validSwedishMobileNumber(value, props) {
    return validAbstractPhoneNumber(value, props, (number) => {
        console.log("nf:", number);
        return number.length == 10;
    });
}

export function validSwedishPhoneNumber(value, props) {
    return validAbstractPhoneNumber(value, props, (number) => {
        return number.length <= 10 && number.length >= 8;
    });
}

// lazy swedish zip validation
export function validSwedishZipCode(value, props) {
    if (value.length !== 5 || isNaN(parseInt(value))) {
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function validYearAndMonth(value, props) {
    const [year, month] = value.split('-')
        .map(v => parseInt(v.replace(/^[0]+/g, '')));

    if (value.length > 7
        || typeof isPositiveInteger(month) !== 'undefined'
        || typeof isPositiveInteger(year) !== 'undefined'
        || month > 12 )
    {
            return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function isValidDate(value, props) {
    if (!isISO8601(value) || value.length !== 10) {
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

export function isValidFutureDate(value, props) {
    let now = moment();
    if (typeof isValidDate(value, props) !== 'undefined' || now.isAfter(moment(value), 'day')) {
        return typeof props !== 'undefined' ? <ErrorMessage forId={props.id} /> : false;
    }
}

// don't forget to bind or use call/apply!

export function passedApiValidation(inputKey, inputName, premise) {
    return (value, props) => {
        if (typeof premise !== 'undefined') {
            let localValidation = premise(value, props);
            if (typeof localValidation !== 'undefined') { // !== undefined => there's an error
                return localValidation;
            }
        }

        let input = this.apiValidationInputs[inputKey][inputName];
        if (input.invalidated) {
            return <ErrorMessage message={input.errorMessage} />;
        }
    };
}

/* If supplied value is blank, no validation is performed */
export function blankOrPassesValidation(validationFunction) {
    return (value, props) => {
        if (value == '') {
            return;
        }

        return validationFunction(value, props);
    }
}